import { ComponentChildren, FunctionalComponent } from "preact";

import { Icon } from "@/icons";
import { Heading, Highlight, Text, TextButton } from "@/uikit";

import { IconKey } from "@/icons/sprite";
import { ModalControls } from "@/uikit/Modal";

import "./style.css";

import clsx from "clsx";

export type OnboardingType = "general";

type OnboardingProps = {
  controls: ModalControls;
  type: OnboardingType;
};

type OnboardingPoint = {
  text: ComponentChildren;
  icon: IconKey;
};

const getOnboardingPoints = (type: OnboardingType) => {
  const generalOnboardingPoints: OnboardingPoint[] = [
    {
      text: (
        <>
          <Text embed weight="semibold">
            up to <Highlight>4.5%</Highlight>
          </Text>{" "}
          from Tonstakers Staking
        </>
      ),
      icon: "percent",
    },
    {
      text: (
        <>
          <Text embed weight="semibold">
            up to <Highlight>11%</Highlight>
          </Text>{" "}
          with Tonstakers Earn
        </>
      ),
      icon: "hexagon",
    },
    {
      text: (
        <>
          <Text embed weight="semibold">
            more <Highlight>rewards</Highlight>
          </Text>{" "}
          with Tonstakers Tokens
        </>
      ),
      icon: "uparrow",
    },
  ];

  const onboardingPoints: Record<OnboardingType, OnboardingPoint[]> = {
    general: generalOnboardingPoints,
  };

  return onboardingPoints[type];
};

type ContentType = "heading" | "button";

const content: Record<
  OnboardingType,
  Record<ContentType, ComponentChildren>
> = {
  general: {
    heading: "Earn with Tonstakers",
    button: "Stake to Earn",
  },
};

export const Onboarding: FunctionalComponent<OnboardingProps> = (
  { controls, type },
) => {
  const onboardingPoints = getOnboardingPoints(type);

  return (
    <div className={clsx("onboarding", "onboarding-" + type)}>
      <Heading level={1}>{content[type].heading}</Heading>
      <div className="onboarding-points gap-vertical">
        {onboardingPoints.map((point) => (
          <div className="onboarding-point" key={point.icon}>
            <Icon iconKey={point.icon} />
            <Text variant="h4">{point.text}</Text>
          </div>
        ))}
      </div>
      <div className="onboarding-buttons">
        <TextButton onClick={controls.close}>{content[type].button}</TextButton>
      </div>
    </div>
  );
};
